import React, { useEffect, useState } from "react";
import {
  View,
  ImageBackground,
  TouchableOpacity,
  StyleSheet,
  useWindowDimensions,
  ViewStyle,
  Text,
} from "react-native";
import { UsersLive } from "../index";
import { MainUsersLiveFramePng } from "../../../assets";
import { getButtonImageByLanguage } from "../../../assets/buttonsByLanguage";
import LoginModal from "../Modals/LoginModal";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { getSocket } from "../../../services/socket";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLogged } from "../../../store/auth/authReducer";
import { useDevice } from "../../../utils/hooks/useDevice";
import { activeUsersRequest } from "../../../store/lobby/lobbyActions";
import {
  selectActiveUsersCount,
  selectActiveUsersLoading,
  selectTotalActiveUsersCount,
  selectTournamentUsersCount,
  selectVipUsersCount,
} from "../../../store/lobby/lobbySagas";
import ErrorFindTableModal from "../Modals/ErrorFindTableModal";
import InviteNotificationModal from "../Modals/InviteNotificationModal";
interface InviteData {
  name: string;
  username: string;
  table: string;
  table_name: string;
  legacyRoomId?: number;
  url: string;
  inviteId: string;
  inviterPlayerId: string;
  inviterUsername: string;
  tableName: string;
}
type NavigationProp = NativeStackNavigationProp<RootStackParamList, "Game">;
const MiddleSection = () => {
  const { width, height } = useWindowDimensions();
  const [isClient, setIsClient] = useState(false);
  const { navigate } = useNavigation<Nav>();
  const isLogged = useSelector(selectIsLogged);
  const { isXs, isSm, isMd, isLg, isXLg } = useDevice();
  const navigation = useNavigation<NavigationProp>();
  const dispatch = useDispatch();
  const normalCount = useSelector(selectActiveUsersCount);
  const vipCount = useSelector(selectVipUsersCount);
  const tournamentCount = useSelector(selectTournamentUsersCount);
  const totalCount = useSelector(selectTotalActiveUsersCount);
  const langCode = useSelector((s: any) => s.i18n?.langCode ?? "en");
  const auth = useSelector((s: any) => s.auth);
  const playerId = auth?.user?.id || "";
  const username = auth?.user?.username || "";
  const isVip = auth?.user?.isVip || false;
  const [isFindingTable, setIsFindingTable] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [inviteData, setInviteData] = useState<InviteData | null>(null);
  const [showInviteNotification, setShowInviteNotification] = useState(false);
  const [showRecoveryModal, setShowRecoveryModal] = useState(false);
  const timeoutRef = React.useRef<any>(null);

  useEffect(() => {
    if (!isLogged || !playerId || !username) return;

    const socket = getSocket(String(playerId), String(username));

    const handleRecovering = (data: any) => {
      console.log("Service recovering...", data);
      setIsFindingTable(false);
      setShowRecoveryModal(true);
    };

    const handleRecovered = () => {
      console.log("Service recovered!");
      setShowRecoveryModal(false);
    };

    socket.on("game:recovering", handleRecovering);
    socket.on("game:recovered", handleRecovered);

    return () => {
      socket.off("game:recovering", handleRecovering);
      socket.off("game:recovered", handleRecovered);
    };
  }, [isLogged, playerId, username]);

  useEffect(() => {
    if (!isLogged || !playerId || !username) return;

    const socket = getSocket(String(playerId), String(username));

    const handleInviteUser = (payload: any) => {
      console.log("INVITE RECEIVED in MiddleSection:", payload);
      const data = payload.data || payload;

      const invitePayload = {
        name: data.name || data.inviterUsername,
        username: data.username || data.inviterUsername,
        table: data.table,
        table_name: data.table_name || data.tableName,
        legacyRoomId: data.legacyRoomId,
        url: data.url,
        inviteId: data.notification_id || data.inviteId,
        inviterPlayerId: data.inviterPlayerId,
        inviterUsername: data.inviterUsername,
        tableName: data.tableName,
      };

      console.log("Setting invite data in MiddleSection:", invitePayload);
      setInviteData(invitePayload);
      setShowInviteNotification(true);
    };

    // Listen for invite events
    socket.on("inviteUser", handleInviteUser);

    // Cleanup
    return () => {
      socket.off("inviteUser", handleInviteUser);
    };
  }, [isLogged, playerId, username]);

  useEffect(() => {
    if (!isLogged || !playerId || !username) return;

    const socket = getSocket(String(playerId), String(username));
    const stopFinding = () => {
      setIsFindingTable(false);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const handleQuickSeat = (packet: any) => {
      stopFinding();
      console.log("Quick seat response:", packet);
      setIsFindingTable(false);

      const data = packet?.data || packet || {};

      if (packet?.success && data.tableId) {
        console.log("Navigating to table:", data.tableId);

        navigation.replace("Game", {
          tableId: data.tableId,
          roomSlug: data.roomSlug,
          isTournamentRoom: false,
        });
      } else {
        const error =
          packet?.error || "Unable to find available table. Please try again.";
        console.error("uick seat failed:", error);
        setErrorMessage(error);
        setShowErrorModal(true);
      }
    };

    const handleSeatNotFound = (packet: any) => {
      stopFinding();
      console.log("handleSeatNotFound event received:", packet);

      if (
        packet?.method === "tableSeatNotFound" ||
        (!packet?.success &&
          packet?.data &&
          Object.keys(packet.data).length === 0)
      ) {
        setIsFindingTable(false);

        const error =
          packet?.error || "Unable to find available table. Please try again.";
        console.error("Get active table failed:", error);
        setErrorMessage(error);
        setShowErrorModal(true);
      } else if (packet?.success && packet?.data?.tableId) {
        setIsFindingTable(false);
        console.log("Navigating to table from getTable:", packet.data.tableId);
        navigate("Game", {
          tableId: packet.data.tableId,
          legacyRoomId: packet.data.legacyRoomId,
          isTournamentRoom: false,
        });
      }
    };

    socket.on("quickSeat", handleQuickSeat);
    socket.on("tableSeatNotFound", handleSeatNotFound);

    return () => {
      socket.off("quickSeat", handleQuickSeat);
      socket.off("tableSeatNotFound", handleSeatNotFound);
    };
  }, [isLogged, playerId, username, navigate]);

  useEffect(() => {
    dispatch(activeUsersRequest());
  }, [dispatch]);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  const isPortrait = height >= width;
  const isMobile = isPortrait || width < 600;

  // const SMALL_SIZE = isPortrait ? width * 0.5 : width * 0.25;
  // const LARGE_SIZE = isPortrait ? width * 0.62 : width * 0.35;
  const SMALL_SIZE = isPortrait ? height * 0.26 : width * 0.25;
  const LARGE_SIZE = isPortrait ? height * 0.32 : width * 0.35;

  const badgeSize = SMALL_SIZE * 0.26;
  const badgeLeft = SMALL_SIZE * 0.8;
  const badgeTop = SMALL_SIZE * 0.46;

  const containerStyle = {
    flexDirection: isMobile ? "column" : ("row" as const),
    alignItems: "center" as const,
    justifyContent: "center" as const,
    flexWrap: "nowrap" as const,
    // minHeight: isMobile ? height * 0.7 : undefined,
  };

  const getButtonStyle = (isMobile: boolean, index: number) => {
    if (isMobile) {
      return {
        marginBottom: index !== 2 ? 1 : 0,
      };
    } else {
      return {
        marginHorizontal: 12,
      };
    }
  };
  type Nav = NativeStackNavigationProp<RootStackParamList>;

  const handleTryAgain = () => {
    setShowErrorModal(false);
    setIsFindingTable(true);

    const socket = getSocket(String(playerId), String(username));
    socket.emit("service:getActiveTable", {
      gameVersion: 4,
      attempt: 1,
    });
  };

  const handleGoToLobby = () => {
    setShowErrorModal(false);
    navigate("Lobby");
  };

  const handleCancelError = () => {
    setShowErrorModal(false);
  };

  const handleAcceptInvite = () => {
    if (!inviteData) return;

    const socket = getSocket(String(playerId), String(username));

    const responsePayload = {
      inviteId: inviteData.inviteId,
      response: "accept",
      table: inviteData.table,
    };

    socket.emit("svara:respondToInvite", responsePayload);

    setShowInviteNotification(false);
    // Navigate to the game
    navigate("Game", {
      tableId: inviteData.table,
      legacyRoomId: inviteData.legacyRoomId,
      isTournamentRoom: false,
    });

    setInviteData(null);
  };

  const handleRejectInvite = () => {
    if (!inviteData) return;

    const socket = getSocket(String(playerId), String(username));

    const responsePayload = {
      inviteId: inviteData.inviteId,
      response: "reject",
      table: inviteData.table,
    };

    socket.emit("svara:respondToInvite", responsePayload);
    setShowInviteNotification(false);
    setInviteData(null);
  };

  const formatCount = (count: number | undefined): string => {
    if (!count || count === 0) return "0";

    if (count >= 1000000) {
      return (count / 1000000).toFixed(1) + "M";
    }

    if (count >= 1000) {
      const thousands = count / 1000;
      return thousands % 1 === 0
        ? thousands.toFixed(0) + "K"
        : thousands.toFixed(1) + "K";
    }

    return count.toString();
  };

  return (
    <>
      <View
        style={[
          styles.container,
          containerStyle as ViewStyle,
          { width: width, height: height * 0.7 },
        ]}
      >
        {/* VIP Button */}
        <View
          style={[
            {
              width: SMALL_SIZE,
              height: SMALL_SIZE - 50,
              alignItems: "center",
            },
            getButtonStyle(isMobile, 0),
          ]}
        >
          <ImageBackground style={{ width: SMALL_SIZE, height: SMALL_SIZE }}>
            <TouchableOpacity
              onPress={() => navigate("VipTables")}
              style={{
                width: SMALL_SIZE * 0.95,
                height: SMALL_SIZE * 0.95,
              }}
            >
              <ImageBackground
                source={getButtonImageByLanguage("vip", langCode)}
                style={styles.inner}
              >
                <View style={StyleSheet.absoluteFillObject}>
                  <ImageBackground
                    source={MainUsersLiveFramePng}
                    style={{
                      position: "absolute",
                      width: badgeSize,
                      height: badgeSize,
                      left: badgeLeft,
                      top: badgeTop,
                      transform: [
                        { translateX: -badgeSize / 2 },
                        { translateY: -badgeSize / 2 },
                      ],

                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      adjustsFontSizeToFit
                      style={{
                        color: "#ffe593",
                        marginTop: 12,
                        fontSize: isXs
                          ? 14
                          : isSm
                            ? 14
                            : isMd
                              ? 16
                              : isLg
                                ? 20
                                : isXLg
                                  ? 26
                                  : 20,
                        width: "70%",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {formatCount(vipCount)}
                    </Text>
                  </ImageBackground>
                </View>
              </ImageBackground>
            </TouchableOpacity>
          </ImageBackground>
        </View>

        {/* PLAY NOW Button with loading state */}
        <View
          style={[
            {
              width: LARGE_SIZE,
              height: LARGE_SIZE - 50,
              alignItems: "center",
            },
            getButtonStyle(isMobile, 1),
          ]}
        >
          <ImageBackground style={{ width: LARGE_SIZE, height: LARGE_SIZE }}>
            <TouchableOpacity
              onPress={() => {
                if (!isLogged) {
                  navigate("Login");
                  return;
                }

                console.log("Requesting active table...");
                if (isFindingTable) return; // проста защита от spam taps
                setIsFindingTable(true);

                // safety timeout (ако няма отговор)
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => {
                  setIsFindingTable(false);
                  setErrorMessage("No response from server. Please try again.");
                  setShowErrorModal(true);
                }, 8000);

                const socket = getSocket(String(playerId), String(username));
                const payload = { gameVersion: 4, attempt: 1 };

                const emitRequest = () => {
                  console.log("📤 emit service:getActiveTable");
                  socket.emit("service:getActiveTable", payload);
                };

                if (socket.connected) {
                  emitRequest();
                } else {
                  console.log("⏳ waiting for socket connect then emit...");
                  socket.once("connect", emitRequest);
                  socket.connect?.(); // harmless if already trying
                }
              }}
              disabled={isFindingTable}
              style={{
                width: LARGE_SIZE * 0.95,
                height: LARGE_SIZE * 0.95,
                opacity: isFindingTable ? 0.5 : 1,
              }}
            >
              <ImageBackground
                source={getButtonImageByLanguage("playNow", langCode)}
                style={styles.inner}
              >
                <View style={StyleSheet.absoluteFillObject}>
                  <ImageBackground
                    source={MainUsersLiveFramePng}
                    style={{
                      position: "absolute",
                      width: badgeSize,
                      height: badgeSize,
                      left: LARGE_SIZE * 0.82,
                      top: LARGE_SIZE * 0.46,
                      transform: [
                        { translateX: -badgeSize / 2 },
                        { translateY: -badgeSize / 2 },
                      ],

                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      adjustsFontSizeToFit
                      style={{
                        color: "#ffe593",
                        marginTop: 12,
                        fontSize: isXs
                          ? 14
                          : isSm
                            ? 14
                            : isMd
                              ? 16
                              : isLg
                                ? 20
                                : isXLg
                                  ? 26
                                  : 20,
                        width: "70%",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {formatCount(totalCount)}
                    </Text>
                  </ImageBackground>
                </View>
              </ImageBackground>
            </TouchableOpacity>
          </ImageBackground>
        </View>

        {/* TOURNAMENTS Button */}
        <View
          style={[
            {
              width: SMALL_SIZE,
              height: SMALL_SIZE - 50,
              alignItems: "center",
            },
            getButtonStyle(isMobile, 2),
          ]}
        >
          <ImageBackground style={{ width: SMALL_SIZE, height: SMALL_SIZE }}>
            <TouchableOpacity
              onPress={() => {
                if (isLogged) {
                  navigate("Tournaments");
                } else {
                  navigate("Login");
                }
              }}
              style={{
                width: SMALL_SIZE * 0.95,
                height: SMALL_SIZE * 0.95,
              }}
            >
              <ImageBackground
                source={getButtonImageByLanguage("tournaments", langCode)}
                style={styles.inner}
              >
                <View style={StyleSheet.absoluteFillObject}>
                  <ImageBackground
                    source={MainUsersLiveFramePng}
                    style={{
                      position: "absolute",
                      width: badgeSize,
                      height: badgeSize,
                      left: badgeLeft,
                      top: badgeTop,
                      transform: [
                        { translateX: -badgeSize / 2 },
                        { translateY: -badgeSize / 2 },
                      ],

                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      adjustsFontSizeToFit
                      style={{
                        color: "#ffe593",
                        marginTop: 12,
                        fontSize: isXs
                          ? 14
                          : isSm
                            ? 14
                            : isMd
                              ? 16
                              : isLg
                                ? 20
                                : isXLg
                                  ? 26
                                  : 20,
                        width: "70%",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {formatCount(tournamentCount)}
                    </Text>
                  </ImageBackground>
                </View>
              </ImageBackground>
            </TouchableOpacity>
          </ImageBackground>
        </View>

        {/* {isLoginModalOpen && (
        <LoginModal
          onClose={() => {
            setIsLoginModalOpen(false);
          }}
          data={{
            username: "",
            mobileNumber: "",
            password: "",
          }}
          errors={{
            username: undefined,
            mobileNumber: undefined,
            password: undefined,
          }}
          onSave={function (): void {
            throw new Error("Function not implemented.");
          }}
          onChange={function (
            name: keyof {
              username: string;
              mobileNumber: string;
              password: string;
            },
            value: string
          ): void {
            throw new Error("Function not implemented.");
          }}
          identity={"username"}
          loading={false}
          setIdentity={function (i: "username" | "phone"): void {
            throw new Error("Function not implemented.");
          }}
          setAlert={function (alert: {
            type: "error" | "success";
            message: string;
          }): void {
            throw new Error("Function not implemented.");
          }}
          onSuccess={function (token: string): void {
            throw new Error("Function not implemented.");
          }}
        />
      )} */}
      </View>

      <ErrorFindTableModal
        visible={showErrorModal}
        title="No Table Available at the moment."
        message={errorMessage}
        onTryAgain={handleTryAgain}
        onGoToLobby={handleGoToLobby}
        onCancel={handleCancelError}
      />

      {showInviteNotification && inviteData && (
        <InviteNotificationModal
          visible={showInviteNotification}
          inviteData={inviteData}
          onAccept={handleAcceptInvite}
          onReject={handleRejectInvite}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 10,
  },
  inner: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },
  badgeStyle: {
    position: "absolute",
    top: "42%",
    right: 16,
    width: 98,
    height: 98,
  },
  sparkleStyle: {
    position: "absolute",
    bottom: 11,
    left: 16,
    width: 90,
    height: 90,
  },
  textStyle: {
    position: "absolute",
    color: "#ffe593",
    fontSize: 20,
    width: 75,
    top: 46,
    right: 12,
    textAlign: "center",
    fontWeight: "bold",
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  loadingText: {
    color: "#ffe593",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default MiddleSection;
